import { vShow as _vShow, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-64b138d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "gradientBg3D",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_gradient_bg = _resolveComponent("gradient-bg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("canvas", {
      ref: "cv",
      key: _ctx.cvKey
    })), [
      [_vShow, _ctx.glOk]
    ]),
    (!_ctx.glOk)
      ? (_openBlock(), _createBlock(_component_gradient_bg, {
          key: 0,
          variant: _ctx.variant,
          animated: _ctx.animated
        }, null, 8, ["variant", "animated"]))
      : _createCommentVNode("", true)
  ]))
}